import { Controller } from "@hotwired/stimulus"

export default class AccordionController extends Controller {
  static targets = ["item"]
  static values = { multiple: Boolean }

  declare readonly itemTargets: HTMLDetailsElement[]
  declare readonly multipleValue: boolean

  toggle(event: Event): void {
    const details = event.currentTarget as HTMLDetailsElement
    if (!details.open || this.multipleValue) return
    this.itemTargets.forEach((other) => {
      if (other !== details) other.removeAttribute("open")
    })
  }
}
